import React from "react"

import { pagesLinks } from "../../../../pages-data/_V2/common/links"

import colors from "../../../../styles/_V2/export.module.scss"

import ApplicationAndWebsite from "../assets/dropdownItemsIcons/ApplicationAndWebsite"
import LoyaltyCards from "../assets/dropdownItemsIcons/LoyaltyCards"
import OnlineMenu from "../assets/dropdownItemsIcons/OnlineMenu"
import ElectronicQueue from "../assets/dropdownItemsIcons/ElectronicQueue"
import CustomersDisplay from "../assets/dropdownItemsIcons/CustomersDisplay"

export const guestsIconColor = colors.blueSky
export const guestsItemHoverColor = colors.blueSkyLightBg

export const guestsItems = {
	indexWL: {
		icon: <ApplicationAndWebsite />,
		name: "Приложение и сайт",
		mobileName: "Приложение\nи сайт",
		description: "Выбор по меню, оплата, доставка, самовывоз",
		link: pagesLinks.indexWL,
	},
	passkit: {
		icon: <LoyaltyCards />,
		name: "Карты лояльности",
		mobileName: "Карты\nлояльности",
		description: "Бонусные программы, акционные предложения, комбо",
		link: pagesLinks.passkit,
	},
	wlShop: {
		icon: <OnlineMenu />,
		name: "Электронное меню",
		mobileName: "Электронное меню",
		description: "Для случаев, когде не нужно бумажное меню",
		link: pagesLinks.wlShop.index,
	},
	line: {
		icon: <ElectronicQueue />,
		name: "Электронная очередь",
		mobileName: "Электронная\nочередь",
		description: "Обслуживание клиентов \nв пиковые часы",
		link: pagesLinks.line,
	},
	customersDisplay: {
		icon: <CustomersDisplay />,
		name: "Экран покупателя",
		mobileName: "Экран\nпокупателя",
		description: "Наглядная информация о заказе для гостя",
		link: pagesLinks.customerDisplay,
	},
}
